import React from "react";
import { Box, Tooltip } from "@mui/material";

interface SimpleHoverComponentProps {
  title: string;
  children: React.ReactNode;
}

const SimpleHoverComponent: React.FC<SimpleHoverComponentProps> = ({
  title,
  children,
}) => {
  if (!title) return <>{children}</>;

  return (
    <Tooltip title={title} followCursor>
      <Box>{children}</Box>
    </Tooltip>
  );
};

export default SimpleHoverComponent;
